import { inject, Injectable, signal } from '@angular/core';
import { BsApiService, GenericResponseResult } from '@brightside-web/desktop/data-access/core-services';
import { Survey, SurveyQuestionGroup, SurveyQuestionnairePayload, SurveyStatus } from './models/survey.model';
import { BehaviorSubject, from, Observable, of } from 'rxjs';
import { Router } from '@angular/router';

@Injectable()
export class SurveyQuestionnaireService {

  _router = inject(Router);
  _canGoHome = signal<boolean>(true);
  _goHomeCalled = signal<string | null>(null);
  _surveyData = signal<Survey | undefined>(undefined);

  isOnboarding: boolean;

  private _surveyData$: BehaviorSubject<Survey | undefined> = new BehaviorSubject<Survey | undefined>(undefined);

  surveyData$: Observable<Survey | undefined> = this._surveyData$.asObservable();
  surveyType: string = '';


  constructor(
    private _bsApi: BsApiService
  ) {}

  setSurveyType(type: string): void {
    this.surveyType = type;
  }

  getSurveyData(type: string): Observable<SurveyQuestionnairePayload & GenericResponseResult> {
    return this._bsApi.get<SurveyQuestionnairePayload>('api-mobile', `/survey/${type}`);
  }

  setSurveyData(survey: Survey) {
    this._surveyData$.next(survey);
    this._surveyData.set(survey);
  }

  updateSurveyData(
    type: string,
    surveyId: string,
    questionGroups: SurveyQuestionGroup[],
    isComplete: boolean = false
  ): Observable<SurveyQuestionnairePayload & GenericResponseResult> {
    return this._bsApi.post<SurveyQuestionnairePayload>('api-mobile', `/survey/${type}`, {
      surveyId,
      questionGroups,
      isComplete,
    });
  }

  disableBackToHome() {
    this.setGoHomeAllowed(false);
  }

  backToHomeCalled(step?: string) {
    if (this._canGoHome()) {
      this._router.navigate(['home']);
    } else {
      this._goHomeCalled.set(step ?? null);
    }
  }

  resetGoHomeCalled() {
    this._goHomeCalled.set(null);
  }

  setGoHomeAllowed(allowed: boolean) {
    this._canGoHome.set(allowed);
  }
}
